import axios from "axios";

const URL = {
    base: "/api/cdk/dealername/v1/"
};

const HEADERS = {
    "Content-Type": "application/json"
};

const DealerNameService = {
    getDealerStoresNames: async () => {
        try {
            const response = await axios.get(`${URL.base}`, { headers: HEADERS });
            const dealerNames = response.data;

            return dealerNames;
        } catch (e) {
            console.error(
                "An error has occurred while trying to load the dealer names",
                e
            );
            return { hasError: true };
        }
    }
};

export default DealerNameService;